import React, { useEffect, useState } from "react";
import { Dialog, Slide, Backdrop, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddStoreForm from "layouts/stores/components/newStore";
import { useGetSpecificStoreQuery } from "../redux/Slices/storeApi";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AddStoreModal = ({ open, onClose, onUserAdded, initialData }) => {
  console.log("🚀 ~ AddStoreModal ~ initialData:", initialData);
  const [storeData, setStoreData] = useState(null);
  const { data, isLoading } = useGetSpecificStoreQuery(initialData?.id);
  console.log(`🚀 ~ AddStoreModal ~ storeData ${initialData?.id}`, data);
  useEffect(() => {
    if (data) {
      setStoreData(data?.data);
    }
  }, [data]);

  const onCancel = () => {
    onClose();
    setStoreData(null);
  };
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      scroll="paper"
      fullWidth
      maxWidth="lg"
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
      PaperProps={{
        style: {
          marginTop: "15vh",
          borderRadius: "16px",
          overflow: "auto", // ✅
          maxHeight: "90vh", // ✅
        },
      }}
    >
      <IconButton
        onClick={onCancel}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: "text.main",
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>

      <AddStoreForm
        initialData={storeData} // Pass initial data
        onClose={onCancel}
        onSuccess={() => {
          onClose();
          onUserAdded();
        }}
      />

    </Dialog>
  );
};

export default AddStoreModal;
